/**
 * Whether a page path belongs to the Monday app embedded in a Monday item view.
 *
 * The proxy, the provider tree and the analytics bootstrap all use this one
 * check, so the embedded surface never mounts the website session, analytics,
 * chat or consent. It is segment-aware: the root and every path below it match,
 * a sibling such as `/integrations/monday-foo` does not. It imports nothing,
 * because the proxy and the early client bootstrap load it on every request.
 */
const EMBEDDED_ROOT = "/integrations/monday";

export function isEmbeddedIntegrationPath(pathname: string): boolean {
  return pathname === EMBEDDED_ROOT || pathname.startsWith(`${EMBEDDED_ROOT}/`);
}
